(() => {
  const ORDER = {
    flavor: ['Bright & Fruity', 'Delicate & Dynamic', 'Smooth & Chocolatey'],
    country: ['Colombia', 'Costa Rica', 'El Salvador', 'Ethiopia', 'Guatemala', 'Panama', 'Tanzania'],
    classification: ['brown-label', 'gold-label', 'black-label', 'diamond-reserve'],
    process: ['washed', 'natural', 'honey', 'fermented', 'decaffeinated']
  };

  const LABELS = {
    classification: {
      'diamond-reserve': 'Diamond Reserve',
      'black-label': 'Black Label',
      'gold-label': 'Gold Label',
      'brown-label': 'Brown Label'
    },
    process: {
      washed: 'Washed',
      honey: 'Honey',
      natural: 'Natural',
      fermented: 'Experimental',
      decaffeinated: 'Decaf'
    }
  };

  function keyFor(groupBy, raw) {
    const v = (raw || '').trim();
    if (!v) return 'other';
    const n = v.toLowerCase().replace(/_/g, '-');

    if (groupBy === 'flavor' || groupBy === 'country') {
      const match = ORDER[groupBy].find((item) => item.toLowerCase() === n);
      return match || v;
    }

    // Classification: exact metaobject handle / title only.
    // Substring matching was putting Brown Label into Gold.
    if (groupBy === 'classification') {
      if (n === 'diamond-reserve' || n === 'diamond reserve' || n === 'diamond') return 'diamond-reserve';
      if (n === 'black-label' || n === 'black label' || n === 'black') return 'black-label';
      if (n === 'brown-label' || n === 'brown label' || n === 'brown') return 'brown-label';
      if (n === 'gold-label' || n === 'gold label' || n === 'gold') return 'gold-label';
      return 'other';
    }

    if (groupBy === 'process') {
      if (n === 'decaffeinated' || n === 'decaf' || n.indexOf('decaf') !== -1) return 'decaffeinated';
      if (n === 'fermented' || n === 'experimental' || n.indexOf('ferment') !== -1 || n.indexOf('experimental') !== -1) return 'fermented';
      if (n === 'honey' || n === 'honey-process' || n === 'honey process' || n.indexOf('honey') !== -1) return 'honey';
      if (n === 'natural' || n === 'natural-process' || n === 'natural process' || n.indexOf('natural') !== -1) return 'natural';
      if (n === 'washed' || n === 'washed-process' || n === 'washed process' || n.indexOf('wash') !== -1) return 'washed';
      return 'other';
    }

    return ORDER[groupBy] && ORDER[groupBy].indexOf(v) !== -1 ? v : 'other';
  }

  function init() {
    const params = new URLSearchParams(window.location.search);
    const groupBy = (params.get('group_by') || '').trim();
    const nav = document.querySelector('.sb-shop-by');
    const sortBy = (params.get('sort_by') || (nav && nav.getAttribute('data-sb-default-sort')) || '').trim();
    const valid = Object.prototype.hasOwnProperty.call(ORDER, groupBy) ? groupBy : '';

    document.querySelectorAll('.sb-shop-by__link').forEach((link) => {
      const linkGroup = link.getAttribute('data-sb-group') || '';
      const linkSort = link.getAttribute('data-sb-sort') || '';
      const isActive = linkGroup ? linkGroup === valid : !valid && linkSort === sortBy;
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });

    const grid = document.querySelector('[data-sb-shop-by-grid]');
    if (!grid) return;

    const promos = Array.from(grid.querySelectorAll('.product-card--promo'));
    // Unwrap earlier groups first so refreshes preserve every card exactly once.
    Array.from(grid.children).filter(child => child.classList.contains('sb-group')).forEach(group => {
      Array.from(group.children).filter(child => child.classList.contains('product-card')).forEach(card => grid.appendChild(card));
      group.remove();
    });

    function makeGroup(label, items) {
      const group = document.createElement('div');
      group.className = 'sb-group';
      const heading = document.createElement('div');
      heading.className = 'sb-group-head';
      const title = document.createElement('h2');
      title.className = 'sb-group-head__label';
      title.textContent = label;
      heading.appendChild(title);
      group.appendChild(heading);
      items.forEach((card) => group.appendChild(card));
      return group;
    }

    function appendPromos() {
      if (!promos.length) return;
      grid.appendChild(makeGroup('more ways to shop', promos));
    }

    // Matt 2026-09-22: on the plain (ungrouped) view the promo cards stay inside
    // the grid at their Liquid position, as on the live site. Only a grouped view
    // (flavor, country, classification, process) collects them under
    // "more ways to shop".
    if (!valid) {
      return;
    }

    const attr = 'data-sb-' + valid;
    const cards = Array.from(grid.querySelectorAll('.product-card:not(.product-card--promo)'));
    if (!cards.length) {
      appendPromos();
      return;
    }

    Array.from(grid.children).forEach((child) => {
      if (!child.classList.contains('product-card')) child.remove();
    });

    const buckets = new Map();
    ORDER[valid].forEach((key) => buckets.set(key, []));

    cards.forEach((card) => {
      const value = keyFor(valid, card.getAttribute(attr));
      // Preserve missing or new metadata in an explicit fallback group.
      if (!buckets.has(value)) buckets.set(value, []);
      buckets.get(value).push(card);
    });

    const labels = LABELS[valid] || {};
    const frag = document.createDocumentFragment();
    const keys = ORDER[valid].slice();
    buckets.forEach((_, key) => {
      if (keys.indexOf(key) === -1 && key !== 'other') keys.push(key);
    });
    if (valid === 'country') {
      const known = ORDER.country.slice();
      const extra = keys.filter((k) => known.indexOf(k) === -1);
      extra.sort((a, b) => a.localeCompare(b));
      keys.length = 0;
      known.forEach((k) => keys.push(k));
      extra.forEach((k) => keys.push(k));
    }
    keys.push('other');

    keys.forEach((key) => {
      const items = buckets.get(key);
      if (!items || !items.length) return;
      frag.appendChild(makeGroup(key === 'other' ? 'other coffees' : (labels[key] || key), items));
    });

    grid.appendChild(frag);
    appendPromos();
    grid.classList.add('sb-grouped');
  }

  document.addEventListener('collection:reloaded', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
